/** Tiny DOM helpers shared across screens. */
import { settings } from "../store/settings";

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text != null) node.textContent = text;
  return node;
}

export function clear(node: HTMLElement): void {
  node.innerHTML = "";
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Compact number formatting (1.2K, 3.4M), toggleable per settings §8.1. */
export function fmt(n: number): string {
  if (!settings.get("numberAbbrev")) return n.toLocaleString();
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${(n / 1000).toFixed(n < 10000 ? 1 : 0)}K`;
  return `${(n / 1_000_000).toFixed(1)}M`;
}

/** A screen that can be mounted into / removed from the app host. */
export interface Screen {
  mount(host: HTMLElement): void;
  unmount(): void;
}

/** Navigation surface passed to every screen. */
export interface Nav {
  home(): void;
  campaign(): void;
  play(stageId: string): void;
  endless(): void;
  daily(): void;
  puzzles(): void;
  playPuzzle(puzzleId: string): void;
  skills(): void;
  settings(): void;
  leaderboard(): void;
  achievements(): void;
  collection(): void;
  cosmetics(): void;
}
